import type { FC } from 'react';
import { CheckCircleOutlined, DisconnectOutlined } from '@ant-design/icons';
import { Alert } from 'app/components/primitives';
import { useConnectivityStatus } from 'app/hooks/useConnectivityStatus';

// Sits above every route, so it must clear the app's own sticky chrome.
const Z_INDEX = 1100;

// App-wide connectivity state. Deliberately not a toast: being offline is a condition that persists
// until it resolves, and an auto-dismissing message would leave the UI claiming nothing is wrong.
const ConnectivityBanner: FC = () => {
  const status = useConnectivityStatus();
  if (status === 'online') return null;

  const offline = status === 'offline';
  return (
    <div className="fixed inset-x-0 top-0" style={{ zIndex: Z_INDEX }}>
      <Alert
        banner
        type={offline ? 'warning' : 'success'}
        icon={offline ? <DisconnectOutlined /> : <CheckCircleOutlined />}
        // Assertive while offline so the drop interrupts; polite on recovery so it doesn't cut
        // across whatever a screen reader is already reading.
        role={offline ? 'alert' : 'status'}
        message={
          offline
            ? "You're offline. We'll reconnect automatically."
            : 'Back online'
        }
      />
    </div>
  );
};

export default ConnectivityBanner;
